module.exports = __webpack_public_path__ + "img/1530269237.6d930ec6.jpg";